import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({ providedIn: 'root' })
export class ProductService {
  constructor(private http: HttpClient) {}

  getCMSContent(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: "/" + U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getEshopHTML.service`,
      cmscontentURLobj,
      httpOptions
    );
  }
  accountNoIndividualLoginEligibility(accountNo:any): Observable<any> {
    const payload = { accountNo: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/accountNoIndividualLoginEligibility.service`,
      payload,
      httpOptions
    );
  }


  getProductsByCategory(
    L: string,
    iADF: number = 1,
    C: string, //categoryId
    NS: string, //navigationState
    N: string = '0' //index number
  ): Observable<any> {
    const payload = { categoryId: C, navigationState: NS, No: N };
    return this.http.post(
      `${
        environment.BASE_URL
      }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${
        iADF == 1 ? true : false
      }`,
      payload,
      httpOptions
    );
  }

  getMobileEligibility(accountNo:number): Observable<any> {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/getAccountType.service`,
      payload,
      httpOptions
    );
  }

  generateOTP(accountNo: number,action? : string): Observable<any> {
    const payload = {
      accountNo: accountNo,
      notificationType: 'SMS',
      notificationValue: accountNo,
    };
    let header = httpOptions;
    if(action)
     header= this.setDynamicHeaders(action);
    return this.http.post(
      `${environment.BASE_URL}/generateOtpByAccountNumber`,
      payload,
      header
    );
  }

  validateAlternateContact(alternaticeContactNumber:any): Observable<any> {
    const payload = { contactNumber: alternaticeContactNumber };
    return this.http.post(
      `${environment.ECARE_URL}/validateAlternateContact.service`,
      payload,
      httpOptions
    );
  }

  validateOTP(otpValidation:any):Observable<any>{
    return this.http.post(
      `${environment.BASE_URL}/validateOtpAccountNumber`,
      otpValidation,
      httpOptions
    );
  }

  getAccountType(accountNumber: string):Observable<any>{
    const payload ={"accountNumber":accountNumber};
    return this.http.post(
      `${environment.ECARE_URL}/getAccountType.service`,
      payload,
      httpOptions
    );
  }

  getCountries(sku: string):Observable<any>{
    return this.http.get(
      `${environment.ESHOP_URL}/getCountries/${sku}`,
      httpOptions
    );
  }

  getAccountSummary(accountNo:string) {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/getAccSummary.service`,
      payload,
      httpOptions
    )
  }

  getLibs(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getLibs.service`,
      cmscontentURLobj,
      httpOptions
    );
  }

  

      loginWithCustomAuthentication(accountNo,otp){
    decodeURI
    const payload = {"accountNo":accountNo,"authType":"otp","authValue":otp};
    return this.http.post(
      `${environment.ECARE_URL}/loginWithCustomAuthentication.service`,
      payload,
      httpOptions
    );
  }
  generateOTPLogedInUser(
    accountNo: any,
    notificationValue: any,
    action?: string
  ): Observable<any> {
    let header = httpOptions;
    if(action)
     header= this.setDynamicHeaders(action);
    const payload = {
      accountNo: accountNo,
      notificationType: 'SMS',
      notificationValue: notificationValue,
    };
    return this.http.post(
      `${environment.BASE_URL}/generateOtpByAccountNumber`,
      payload,
      header
    );
  }

  setDynamicHeaders(token: string): any {
    const httpOptions = {
      headers: new HttpHeaders()
        .set('action', `${token}`)
        .set('Content-Type', 'application/json'),
    };
    return httpOptions;
  }
}
